import { gsap, ScrollTrigger } from '../global/gsap';

const initCounters = (counters) => {
    counters.forEach((counter) => {
        const targetValue = parseInt(counter.getAttribute('data-total'), 10);
        const startValue = targetValue / 1.75;

        counter.innerText = `${startValue}`;

        gsap.to(counter, {
            innerText: targetValue,
            duration: 1.5,
            snap: { innerText: 1 },
            scrollTrigger: {
                trigger: counter,
                start: 'top bottom',
            }
        });
    });
};

export default initCounters;
